'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clsx = require('clsx');
const React = require('react');
const reactAriaComponents = require('react-aria-components');
const designSystem = require('@zapier/design-system');
const SecondaryNav_SecondaryNavContext = require('./SecondaryNavContext.cjs.js');
const SecondaryNav_SecondaryNavItemContext = require('./SecondaryNavItemContext.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const navItem = "_nav-item_159s2_1";
const navItemButton = "_nav-item-button_159s2_8";
const navItemLink = "_nav-item-link_159s2_46";
const navItemToggleButton = "_nav-item-toggle-button_159s2_58";
const styles = {
	navItem: navItem,
	navItemButton: navItemButton,
	navItemLink: navItemLink,
	navItemToggleButton: navItemToggleButton
};

const SecondaryNavItem = ({ children, className, label, linkProps, itemKey }) => {
  const { selectedItemKey, expandedSectionKeys, registerSelectedItemKey, registerExpandedSectionKeys } = SecondaryNav_SecondaryNavContext.useSecondaryNavContext();
  const isSelected = selectedItemKey === itemKey;
  const isExpanded = expandedSectionKeys.includes(itemKey);
  const onClick = (e) => {
    var _a;
    registerSelectedItemKey(itemKey);
    (_a = linkProps.onClick) === null || _a === void 0 ? void 0 : _a.call(linkProps, e);
  };
  const onToggle = () => {
    registerExpandedSectionKeys(isExpanded ? expandedSectionKeys.filter((k) => k !== itemKey) : [...expandedSectionKeys, itemKey]);
  };
  const submenuId = `${itemKey}-menu`;
  const contextValue = React.useMemo(() => ({
    itemId: itemKey,
    listId: submenuId
  }), [itemKey, submenuId]);
  return React__default.default.createElement(
    SecondaryNav_SecondaryNavItemContext.SecondaryNavItemContext.Provider,
    { value: contextValue },
    React__default.default.createElement(
      "li",
      { className: clsx.clsx(styles.navItem, className), "data-zds": true },
      React__default.default.createElement(
        "div",
        { className: styles.navItemButton, "data-selected": isSelected, "data-zds": true },
        React__default.default.createElement(designSystem.Link, Object.assign({}, linkProps, { "aria-current": isSelected ? "page" : void 0, className: clsx.clsx(styles.navItemLink, linkProps.className), onClick }), label),
        children && React__default.default.createElement(
          reactAriaComponents.ToggleButton,
          { "aria-controls": submenuId, "aria-expanded": isExpanded, "aria-label": isExpanded ? "Collapse menu" : "Expand menu", className: styles.navItemToggleButton, "data-expanded": isExpanded, "data-zds": true, isSelected: isExpanded, onChange: onToggle },
          React__default.default.createElement(designSystem.Icon, { name: "arrowSmallDown", size: 20, isBlock: true })
        )
      ),
      children
    )
  );
};

exports.SecondaryNavItem = SecondaryNavItem;
//# sourceMappingURL=SecondaryNavItem.cjs.js.map
